var app = angular.module('leonardo');

var PaginationConfig = function (paginationTemplateProvider) {
  paginationTemplateProvider.setPath('views/templates/pager.tpl.html');
};

app.config(['paginationTemplateProvider', PaginationConfig]);
